module.exports = __webpack_public_path__ + "media/images/athletes/2420-b9ecd15f7d249a84fc865e45d31c5dec.png";